const Show = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 14.866q1.2 0 2.033-.833T14.866 12t-.833-2.033T12 9.134t-2.033.833T9.134 12t.833 2.033 2.033.833m-1.322-1.545q.543.545 1.32.545.78 0 1.323-.544.545-.543.545-1.32 0-.78-.544-1.323a1.8 1.8 0 0 0-1.32-.545q-.78 0-1.323.544a1.8 1.8 0 0 0-.545 1.32q0 .78.544 1.323"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 17.73q-2.42 0-4.39-1.226-1.973-1.227-3.15-3.46a2.194 2.194 0 0 1-.242-1.01q0-.282.055-.559.056-.277.186-.52 1.179-2.231 3.15-3.459Q9.581 6.27 12 6.27t4.39 1.227 3.15 3.46q.132.242.187.507a2.6 2.6 0 0 1 0 1.075 1.9 1.9 0 0 1-.186.506q-1.18 2.233-3.15 3.46Q14.419 17.73 12 17.73m4.083-2.238Q14.277 16.731 12 16.731t-4.083-1.239T5.08 12Q6.11 9.746 7.917 8.508 9.723 7.269 12 7.269t4.083 1.239T18.92 12q-1.032 2.254-2.838 3.492"
      clipRule="evenodd"
    />
  </>
)
export default Show
